import React, { useState, useContext } from 'react';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import moment from 'moment';
import 'moment-timezone';
import { useGetEventsQuery } from '../../../redux/slices/eventSlice';
import PublicEventsContext from './PublicEventsContext';

// Components
import TruckEvent from './TruckEvent';
import LocationEvent from './LocationEvent';

// Misc
import styles from './PublicEventsCalendar.module.postcss';
import eventStyles from './PublicEvents.module.postcss';

moment.tz.setDefault('America/Los_Angeles');

function PublicEventsCalendar() {
  const { truckId, locationId } = useContext(PublicEventsContext);
  const localizer = momentLocalizer(moment);

  const startOfMonth = moment().startOf('month').subtract(7, 'days').format('M-D-YY');
  const endOfMonth = moment().endOf('month').add(7, 'days').format('M-D-YY');

  const [selectedEvent, setSelectedEvent] = useState(null);
  const [date, setDate] = useState(moment().toDate());
  const [startDate, setStartDate] = useState(startOfMonth);
  const [endDate, setEndDate] = useState(endOfMonth);

  const { data = {} } = useGetEventsQuery({
    with_active_trucks: true,
    page: 1,
    page_size: 300,
    start_date: startDate,
    end_date: endDate,
    ...(truckId ? { for_trucks: truckId, include_locations: true, include_static_map: true } : {}),
    ...(locationId ? { for_locations: locationId, include_bookings: true } : {}),
  });
  const events = data.events || [];

  const onCalendarNavigate = (newDate, _view) => {
    setStartDate(moment(newDate).startOf('month').subtract(7, 'days').format('M-D-YY'));
    setEndDate(moment(newDate).endOf('month').add(7, 'days').format('M-D-YY'));
    setDate(newDate);
  };

  const onSelectEvent = (event) => {
    setSelectedEvent({
      event: event.originalEvent
    });
  };

  const unselectEvent = () => {
    setSelectedEvent(null);
  };

  let eventsForCalendar = null;
  if (events) {
    eventsForCalendar = events.map((event) => ({
      title: event.display_name,
      start: moment(event.start_time).toDate(),
      end: moment(event.end_time).toDate(),
      originalEvent: event
    }));
  }

  return (
    <div>
      { eventsForCalendar &&
        <div className={styles.PublicCalendar}>
          <Calendar
            events={eventsForCalendar}
            localizer={localizer}
            views={['month']}
            popup
            date={date}
            onSelectEvent={onSelectEvent}
            onNavigate={onCalendarNavigate}
          />
          { selectedEvent &&
            <div
              className={eventStyles.Popup_Event}
              onClick={unselectEvent}
            >
              <div className={eventStyles.Popup_Event_Inner}>
                { truckId &&
                  <TruckEvent
                    event={selectedEvent.event}
                    forCalendar
                  />
                }
                { locationId &&
                  <LocationEvent
                    event={selectedEvent.event}
                    forCalendar
                  />
                }
              </div>
            </div>
          }
        </div>
      }
    </div>
  );
}

export default PublicEventsCalendar;
